import { useTranslation } from 'react-i18next';

export default function BlogHeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-36 pb-20 md:pt-44 md:pb-28 bg-primary-900 overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent-500/[0.03] rounded-full translate-x-1/4 -translate-y-1/3 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/[0.02] rounded-full -translate-x-1/4 translate-y-1/3 blur-3xl"></div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 text-center">
        <p className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">
          {t('blog.hero.titleEn')}
        </p>
        <h1 className="font-heading text-2xl md:text-3xl text-foreground-50 tracking-[0.06em] mb-5">
          {t('blog.hero.title')}
        </h1>
        <div className="gold-line mx-auto mb-6"></div>
        <p className="text-[16px] text-foreground-300 leading-relaxed tracking-[0.04em] max-w-xl mx-auto">
          {t('blog.hero.lead')}
        </p>
      </div>
    </section>
  );
}
